import script from "./InputRangeDualCollateral.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRangeDualCollateral.vue?vue&type=script&setup=true&lang=js"

import "./InputRangeDualCollateral.vue?vue&type=style&index=0&id=72fdaf06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fdaf06"]])

export default __exports__